export const techStackIcons = {
  'JavaScript': { icon: 'devicon-javascript-plain colored', color: '#F7DF1E' },
  'React': { icon: 'devicon-react-original colored', color: '#61DAFB' },
  'Node.js': { icon: 'devicon-nodejs-plain colored', color: '#339933' },
  'TypeScript': { icon: 'devicon-typescript-plain colored', color: '#3178C6' },
  'HTML': { icon: 'devicon-html5-plain colored', color: '#E34F26' },
  'CSS': { icon: 'devicon-css3-plain colored', color: '#1572B6' },
  'Flutter': { icon: 'devicon-flutter-plain colored', color: '#02569B' },
  'Figma': { icon: 'devicon-figma-plain colored', color: '#F24E1E' },
  'react native': { icon: 'devicon-react-original colored', color: '#61DAFB' }, // Added lowercase mapping
  'React Native': { icon: 'devicon-react-original colored', color: '#61DAFB' }, // Added proper case mapping
  'flutter': { icon: 'devicon-flutter-plain colored', color: '#02569B' }, // Added lowercase mapping
  'Swift': { icon: 'devicon-swift-plain colored', color: '#F05138' },
  'swift': { icon: 'devicon-swift-plain colored', color: '#F05138' } // lowercase mapping
};
